import { getProductBadges } from '~/js/utils/product';
import { getIfsInventoryLevels } from '~/js/utils/inventory';

const heroProduct = (id, variantsSkus, images, shopifyData = null, hideSubscriptionOption = false) => ({
  id,
  variantsSkus,
  loading: false,
  shopifyData,
  parentSelectedVariants: [],
  images,
  error: '',
  purchaseType: 'one-time',
  sellingPlanId: null,
  hideSubscriptionOption,

  init() {
    window.heroProduct = this;
    this.sellingPlanId = this.subscriptionPlans?.[0]?.id;

    // We no longer need this, as we update the Shopify inventory. Also this has and causes issues.
    // Keeping the code for reference.
    // this.updateInventoryLevels();
  },

  get ready() {
    return Boolean(!this.loading && this.shopifyData);
  },

  get badges() {
    return this.shopifyData ? getProductBadges(this.shopifyData) : [];
  },

  get subscriptionPlans() {
    return this.shopifyData?.sellingPlanGroups?.[0]?.selling_plans;
  },

  get finalPrice() {
    const variant = this.selectedVariants[0];
    if (!variant) return '';
    return this.purchaseType === 'one-time' ? variant.priceFormatted : variant.sellingPlanAllocationsPrice;
  },

  updateInventoryLevels() {
    const inventoryPromises = [];
    variantsSkus.forEach((sku) => {
      const inventoryPromise = getIfsInventoryLevels(sku);
      inventoryPromises.push(inventoryPromise);
    });

    Promise.all(inventoryPromises)
      .then((inventoryLevels) => {
        inventoryLevels.forEach((inventoryLevel, index) => this.updateVariantAvailability(inventoryLevel, index));
      })
      .catch((error) => console.error(error)); // eslint-disable-line no-console
  },

  updateVariantAvailability(inventoryLevel, index) {
    const variant = this.shopifyData.variants[index];
    if (!variant) return;
    if (typeof inventoryLevel !== 'number') return;

    if (variant?.metafield?.hideVariant) {
      this.updateVariantAvailabilityData(variant);
      return;
    }

    if (inventoryLevel > variant.quantityAvailable) {
      this.updateVariantAvailabilityData(variant, true, inventoryLevel);
    } else {
      this.updateVariantAvailabilityData(variant);
    }
  },

  updateVariantAvailabilityData(variant, isAvailable = false, quantity = 0) {
    variant.availableForSale = isAvailable;
    variant.available = isAvailable;
    variant.inventoryQuantity = quantity;
    variant.quantityAvailable = quantity;
  },
});

export default heroProduct;
